export const LAST_3H = 'last_3h'
export const LAST_24H = 'last_24h'
export const TODAY = 'today'
export const LAST_7_DAYS = 'last_7_days'
export const LAST_30_DAYS = 'last_30_days'
export const CUSTOM = 'custom'

export const presets = [LAST_3H, LAST_24H, TODAY, LAST_7_DAYS, LAST_30_DAYS] //, CUSTOM]

export const presetLabel = {
  [LAST_3H]: 'Last 3 hours',
  [LAST_24H]: 'Last 24 hours',
  [TODAY]: 'Today',
  [LAST_7_DAYS]: 'Last 7 days',
  [LAST_30_DAYS]: 'Last 30 days',
  [CUSTOM]: 'Custom date range'
}

export const CHART_PRESETS = [
  {
    label: 'Last 30 mins',
    startTime: '30m',
    groupBy: '1m'
  },
  {
    label: 'Last 2 hours',
    startTime: '2h',
    groupBy: '3m'
  },
  {
    label: 'Last 6 hours',
    startTime: '6h',
    groupBy: '10m'
  },
  {
    label: 'Last 24 hours',
    startTime: '24h',
    groupBy: '20m'
  },
  {
    label: 'Last 5 days',
    startTime: '5d',
    groupBy: '2h'
  },
]
